import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import CONFIG from '../../config';

const URL = `${CONFIG.API_URL}/operarCursos.php`;
const URL_TRAYECTORIAS = `${CONFIG.API_URL}/operarTrayectorias.php`;
const URL_VALORACIONES = `${CONFIG.API_URL}/operarValoraciones.php`;

function MostrarEncabezadoInstancias({ curso, cursoGrupo, setColInstancias, estudiantes = [], valoraciones = [], recalcularValoraciones }) {
    const navigate = useNavigate();
    const [instancias, setInstancias] = useState([]);
    const [trayectorias, setTrayectorias] = useState([]);

    useEffect(() => {
        obtenerInstancias(curso);
        if (cursoGrupo) {
            obtenerTrayectorias(cursoGrupo);
        }
    }, [curso, cursoGrupo]);

    const obtenerInstancias = (curso) => {
        axios.get(`${URL}?curso=${curso}`)
            .then(res => {
                if (!res.data.error && Array.isArray(res.data.instancias)) {
                    const ordenadas = [...res.data.instancias].sort((a, b) => {
                        const fechaA = a.fecha_inicio ? new Date(a.fecha_inicio).getTime() : (a.fecha_cierre ? new Date(a.fecha_cierre).getTime() : 0);
                        const fechaB = b.fecha_inicio ? new Date(b.fecha_inicio).getTime() : (b.fecha_cierre ? new Date(b.fecha_cierre).getTime() : 0);
                        return fechaA - fechaB;
                    });
                    setInstancias(ordenadas);
                    setColInstancias(ordenadas);
                } else {
                    setInstancias([]);
                    setColInstancias([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const obtenerTrayectorias = (cg) => {
        axios.get(`${URL_TRAYECTORIAS}?id_curso_grupo=${cg}`)
            .then(res => {
                if (Array.isArray(res.data)) {
                    setTrayectorias(res.data);
                } else {
                    setTrayectorias([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    return (
        <>
            {instancias.length > 0 ? instancias.map((i) => {
                const trayEncontrada = trayectorias.find(t => String(t.id_instancia) === String(i.id));

                return (
                    <th key={i.id} style={{ width: '10%' }} className='text-center align-middle'>
                        <div className="d-flex align-items-center justify-content-center gap-1">
                            <span>{i.nombre_instancia}</span>
                            {trayEncontrada && (
                                <button
                                    className="btn btn-sm btn-link text-success p-0"
                                    onClick={() => navigate(`/MC/${curso}/l`, { state: { ver: 'trayectoria', idTrayectoria: trayEncontrada.id } })}
                                    style={{ fontSize: '0.9rem' }}
                                    title={`Ir a Registro de Trayectoria: ${trayEncontrada.titulo}`}
                                    type="button"
                                >
                                    <i className="fa-solid fa-route"></i>
                                </button>
                            )}
                        </div>
                    </th>
                );
            }) : ''}
        </>
    );
}

export default MostrarEncabezadoInstancias;